// Shuffle before selecting authors so books later in the catalog get a turn too.
export function selectDiscoveryBooks(books, random = Math.random) {
  const candidates = (Array.isArray(books) ? books : []).filter(book => {
    if (!book) return false;
    const cover = book.coverImageUrl || book.formats?.find(format => format.coverImageUrl)?.coverImageUrl;
    return cover && /^https?:\/\//i.test(book.productUrl || "");
  });

  for (let index = candidates.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [candidates[index], candidates[swapIndex]] = [candidates[swapIndex], candidates[index]];
  }

  const authors = new Set();
  return candidates.filter(book => {
    if (authors.has(book.authorName)) return false;
    authors.add(book.authorName);
    return true;
  }).slice(0, 3);
}
